import { Controller } from "@hotwired/stimulus"

// lib/useElencoRemoto.js (delta 07 B1) per un Turbo Frame pigro: se la risposta è un errore non HTML (Turbo la
// ignorerebbe e resterebbe la rotella), non contiene il frame (pagina d'errore) o la richiesta fallisce (rete), al posto
// dell'elenco va l'avviso del template, mai un elenco vuoto. Una risposta d'errore HTML con il frame (l'avviso con il
// `detail`, reso dal server) si mostra com'è. «Riprova» rimette il caricamento e ricarica il frame. Le risposte
// tardive le scarta Turbo: un frame tolto dalla pagina annulla la sua richiesta.
export default class extends Controller {
  static targets = ["frame", "avviso"]

  connect() {
    this.caricamento = this.frameTarget.innerHTML
  }

  risposta(event) {
    if (event.target !== this.frameTarget) return
    const r = event.detail.fetchResponse
    if (r.succeeded || r.isHTML) return
    event.preventDefault()
    this.mostraAvviso()
  }

  // turbo:frame-missing: senza preventDefault Turbo svuota il frame e solleva un errore
  mancante(event) {
    if (event.target !== this.frameTarget) return
    event.preventDefault()
    this.mostraAvviso()
  }

  errore(event) {
    if (event.target !== this.frameTarget) return
    event.preventDefault()
    this.mostraAvviso()
  }

  mostraAvviso() {
    this.frameTarget.replaceChildren(this.avvisoTarget.content.cloneNode(true))
  }

  riprova() {
    this.frameTarget.innerHTML = this.caricamento
    this.frameTarget.reload()
  }
}
